import { initializeApp } from "firebase/app";
import firebaseConfig from "./Firebase.config";

const fireInit =()=>{
    initializeApp(firebaseConfig)
};

export default fireInit;
